exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-dashboard-jsx": () => import("./../../../src/pages/dashboard.jsx" /* webpackChunkName: "component---src-pages-dashboard-jsx" */),
  "component---src-templates-material-individual-js": () => import("./../../../src/templates/materialIndividual.js" /* webpackChunkName: "component---src-templates-material-individual-js" */),
  "component---src-templates-materiales-js": () => import("./../../../src/templates/materiales.js" /* webpackChunkName: "component---src-templates-materiales-js" */)
}

